import { createGetPropGetter } from '@/store/utils';

export default {
  spFreelancerRegistrationForthStepValid: createGetPropGetter('spFreelancerRegistrationForthStepValid', false),
  spFreelancerRegistrationCompanySocialNetworkLinkInfo: createGetPropGetter('spFreelancerRegistrationCompanySocialNetworkLinkInfo', {}),
  spFreelancerRegistrationCompanyIpAddressInfo: createGetPropGetter('spFreelancerRegistrationCompanyIpAddressInfo', {}),
  spFreelancerRegistrationCompanyRecommendationInfo: createGetPropGetter('spFreelancerRegistrationCompanyRecommendationInfo', { recommendations: [] }),
  spFreelancerCertificates: createGetPropGetter('spFreelancerCertificates', []),
  spFreelancerServices: createGetPropGetter('spFreelancerServices', []),
  spFreelancerServicesInfo: createGetPropGetter('spFreelancerServicesInfo', {}),
  spFreelancerRegistrationEmailVerificationInfo: createGetPropGetter('spFreelancerRegistrationEmailVerificationInfo', {}),
  spFreelancerRegistrationCurrentStep: createGetPropGetter('spFreelancerRegistrationCurrentStep', 1),
  spFreelancerRegistrationVisitedStepsCnt: createGetPropGetter('spFreelancerRegistrationVisitedStepsCnt', 1),
  spFreelancerRegistrationFilledStepsCnt: createGetPropGetter('spFreelancerRegistrationFilledStepsCnt', 0),
  spFreelancerRegistrationLoadingStatuses: createGetPropGetter('spFreelancerLoading', {}),
  spFreelancerRegistrationLoadingErrors: createGetPropGetter('spFreelancerLoadingErrors', {}),
  spFreelancerRegistrationClientInfo: createGetPropGetter('spFreelancerClientInfo', {}),
  spFreelancerRegistrationRecaptchaToken: createGetPropGetter('spFreelancerRecaptchaToken'),
  spFreelancerEmailVerificationSent: createGetPropGetter('spFreelancerEmailVerificationSent'),
  spFreelancerRegistrationClientAvatar: createGetPropGetter('spFreelancerClientAvatar'),
  spFreelancerRegistrationCompanyCertificationInfo: createGetPropGetter('spFreelancerRegistrationCompanyCertificationInfo'),
  allowNextFirstStepSPFreelancer: state => Boolean(
    state.spFreelancerRegistrationEmailVerificationInfo.workEmail &&
      state.spFreelancerRegistrationEmailVerificationInfo.password &&
      state.spFreelancerRegistrationEmailVerificationInfo.confirmPassword &&
      state.spFreelancerRegistrationEmailVerificationInfo.confirmPassword === state.spFreelancerRegistrationEmailVerificationInfo.password &&
      state.spFreelancerRegistrationEmailVerificationInfo.valid,
  ),
  allowNextSecondStepSPFreelancer: state => Boolean(
    state.spFreelancerClientInfo.firstName &&
      state.spFreelancerClientInfo.lastName &&
      state.spFreelancerClientInfo.jobTitle &&
      state.spFreelancerClientInfo.phoneNumber &&
      state.spFreelancerClientInfo.termsAndConditionsAccepted &&
      state.spFreelancerClientInfo.valid,
  ),
  allowNextThirdStepSPFreelancer: state => Boolean(
    state.spFreelancerServicesInfo.yearsOfExperience &&
    state.spFreelancerServicesInfo.servicesChosen != null &&
    state.spFreelancerClientInfo.valid,
  ),
  allowNextForthStepSPFreelancer: state => Boolean(
    state.spFreelancerRegistrationForthStepValid &&
    state.spFreelancerRegistrationCompanyRecommendationInfo.recommendations &&
      state.spFreelancerRegistrationCompanyRecommendationInfo.recommendations.length >= 2 &&
      state.spFreelancerRegistrationCompanyRecommendationInfo.recommendations[0] &&
      state.spFreelancerRegistrationCompanyRecommendationInfo.recommendations[1],
  ),
};
